import type { LoanEntityDto } from "src/backend"

export const getLoanApplicant = (entities: LoanEntityDto[]) => {
    return entities?.find(entity => entity.label.includes('APPLICANT') ||
        entity.label.includes('EPC') ||
        entity.label.includes('GUARANTOR') ||
        entity.label.includes('PRIMARY_OPERATION_COMPANY'))
}